import * as React from 'react';
import { cn } from '@/utils';

function Badge({ className, variant = 'default', ...props }) {
	const variantStyles = {
		default: 'bg-primary text-primary-foreground border-transparent',
		secondary: 'bg-secondary text-secondary-foreground border-transparent',
		destructive: 'bg-destructive text-destructive-foreground border-transparent',
		outline: 'text-foreground border-border',
	};

	return (
		<div
			className={cn(
				'inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-semibold uppercase tracking-wide',
				variantStyles[variant],
				className
			)}
			{...props}
		/>
	);
}

export { Badge };
